import { Component, Input } from '@angular/core';

@Component({
  selector: 'inc-page-add',
  templateUrl: './page-add.component.html',
  styleUrls: ['./page-add.component.scss'],
})
export class PageAddComponent {
  @Input() title: string;
  @Input() defHref: string;

  constructor() { }

}
